import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { ListNavItemPropDef } from 'components/general/ListNav/ListNav';
import SubNav from 'components/general/SubNav/SubNav';
import toUrl from 'utils/toUrl';

// Recursively flatten nested children to the same level as their parents
const flattenItems = (items: ListNavItemPropDef[]): ListNavItemPropDef[] => (
  R.chain(
    item => [item, ...flattenItems(R.propOr([], 'children', item))],
    items,
  )
);

const getCurrentID = createSelector(
  R.path(['location', 'pathname']),
  (_, ownProps) => R.prop('items', ownProps),
  (pathname: string, items: ListNavItemPropDef[]) => (
    R.pipe(
      flattenItems,
      // Find the link with the current path
      R.find(
        R.pipe(
          R.prop('to'),
          toUrl,
          R.equals(pathname),
        ),
      ),
      R.prop('id'),
    )(items)
  ),
);

/**
 * SubNav, pre-loaded with redux-first-router aware path-matching. This
 * means that 'current' links will be appropriately calculated
 * automatically, much in the same way as the NavLink component.
 */
const SiteSubNav = connect((state, ownProps) => ({
  currentID: getCurrentID(state, ownProps),
}))(SubNav);

export default SiteSubNav;

